module.exports = __webpack_public_path__ + "static/media/file.8128f1f5.svg";